import { useMemo } from "react";

import { useUSBDevices } from "@/hooks/useUSBDevices";
import { OmnipodConstants } from "@/lib/drivers/insulet/OmnipodConstants";

export type OmnipodSource =
  | {
      type: "usb";
      device: USBDevice;
    }
  | {
      type: "manual";
      file: File;
    }
  | undefined;

export const useOmnipodSource = (): OmnipodSource[] => {
  const devices = useUSBDevices([OmnipodConstants.DASH_USB_IDS, OmnipodConstants.EROS_USB_IDS]);

  return useMemo(() => {
    return devices.map(device => ({ type: "usb" as const, device }));
  }, [devices]);
};
